import { render } from "./noWrong.vue?vue&type=template&id=2892d79d&scoped=true"
import script from "./noWrong.vue?vue&type=script&lang=js"
export * from "./noWrong.vue?vue&type=script&lang=js"

import "./noWrong.vue?vue&type=style&index=0&id=2892d79d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2892d79d"]])

export default __exports__